<!--
 * @Author: vince
 * @Date: 2021-09-03 14:20:46
 * @LastEditors: vince
 * @LastEditTime: 2021-09-05 16:04:03
 * @Description:
-->
<template>
	<div class="sys-box">
		<el-container style="height: 100%;">
			<el-aside width="200px">
				<el-menu :default-active="active" class="border-none" @select="menuSelect">
					<el-menu-item index="score">
						<!-- <i class="el-icon-menu"></i> -->
						<span class="menu-label" slot="title">积分管理</span>
					</el-menu-item>
					<el-menu-item index="honor1">
						<!-- <i class="el-icon-document"></i> -->
						<span class="menu-label" slot="title">教师荣誉</span>
					</el-menu-item>
					<el-menu-item index="award">
						<!-- <i class="el-icon-setting"></i> -->
						<span class="menu-label" slot="title">教师获奖</span>
					</el-menu-item>
					<el-menu-item index="teaching">
						<!-- <i class="el-icon-setting"></i> -->
						<span class="menu-label" slot="title">教师教学</span>
					</el-menu-item>
				</el-menu>
			</el-aside>

			<el-container>
				<el-header class="head">
					<span>{{title}}</span>
				</el-header>
				<el-main>
					<router-view></router-view>
				</el-main>
			</el-container>
		</el-container>
	</div>
</template>

<style lang='less'>
</style>

<script>
export default {
	data() {
		return {};
	},
	methods: {
		menuSelect(index, indexPath) {
			this.$router.push({ name: index });
		}
	},
	computed: {
		title() {
			return this.$route.meta.title;
		},
		active() {
			return this.$route.name;
		}
	}
};
</script>
